enum TilgangColumns {
  STED,
  ROLLE,
  HANDLING,
}

export default TilgangColumns;
